import {Chip, Typography} from "@material-tailwind/react";
import {ChevronUpDownIcon} from "@heroicons/react/24/outline";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {BsArrowDown, BsArrowUp} from "react-icons/bs";


const TABLE_HEAD = ["#", "نوع", "مبلغ", "مانده", "وضعیت", "توضیحات", "زمان"];

export function WalletChangesGrid({walletChanges}) {

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <thead>
        <tr>
          {TABLE_HEAD.map((head, index) => (
            <th key={head}
                className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
              <Typography variant="small" color="blue-gray"
                          className="flex items-center justify-between gap-2 font-normal leading-none opacity-70 flex justify-center">
                {head}{" "}
                {index !== TABLE_HEAD.length - 1 && (
                  <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4 sticky "/>
                )}
              </Typography>
            </th>
          ))}
        </tr>
        </thead>
        <tbody className="textCenter">
        {walletChanges.length > 0 && walletChanges.map(
          ({type, amount, remain, status, description, time}, index) => {
            const isLast = index === walletChanges.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={index}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>


                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      variant={type === 'واریز' ? "outlined" : type === 'برداشت' ? 'gradient' : "ghost"}
                      value={type === 'deposit' ? "واریز" : type === 'withdrawal' ? 'برداشت' : type}
                      color={type === "مشاوره" ? "blue" : type === "خدمات" ? "teal" : ''}
                    />
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(Math.abs(amount), true)}
                    </Typography>
                    {amount < 0 ? <BsArrowDown color="red"/> : <BsArrowUp color="green"/>}
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(remain, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      variant="outlined"
                      // color={status === 'موفق' ? "teal" : "red"}
                      value={status === 'successful' ? "موفق" : status === 'failure' ? 'ناموفق' : status}
                    />
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(description)}
                    </Typography>
                  </div>
                </td>


                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(time.split(" ")[1]) + " " + persianNumberFormat(time.split(" ")[0])}
                    </Typography>
                  </div>

                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
      {walletChanges.length === 0 &&
        <Typography className="text-center w-full mt-4">
          تراکنشی انجام نداده اید
        </Typography>
      }
    </div>
  );
}